import SolutionTemplate from "./SolutionTemplate";

const VisitorSolution = () => (
  <SolutionTemplate
    eyebrow="Visitor management"
    title="Digital check-in for"
    titleGradient="every guest"
    subtitle="Replace paper logbooks with a digital visitor register. Guests check in with a photo, host is notified, and visit records are stored securely with full audit trail."
    heroImg="/assets/img/visitor_management.webp"
    heroImgAlt="TimeTango visitor management"
    flowSteps={[
      { title: "Guest arrives", desc: "Receptionist or kiosk captures visitor details and photo" },
      { title: "Host notified", desc: "The host employee receives an instant notification" },
      { title: "Visit logged", desc: "Check-in time, photo and purpose are recorded" },
    ]}
    capabilities={[
      { icon: "📸", title: "Photo capture", desc: "Visitor photo taken at check-in for security" },
      { icon: "🔔", title: "Host notifications", desc: "Instant alerts when a visitor arrives" },
      { icon: "📋", title: "Digital register", desc: "Searchable visitor history with filters" },
      { icon: "🏢", title: "Multi-location", desc: "Manage visitors across all office locations" },
      { icon: "📄", title: "Document upload", desc: "Store ID copies and NDA documents" },
      { icon: "⏱", title: "Check-out tracking", desc: "Track visit duration with check-out time" },
    ]}
    benefits={[
      { title: "No paper logbooks", desc: "Go fully digital — searchable, exportable, secure." },
      { title: "Security compliance", desc: "Photo ID, visit purpose and host approval logged for every visit." },
      { title: "Instant host alerts", desc: "Hosts know the moment their visitor arrives." },
      { title: "Visit analytics", desc: "Track visitor volume, peak times and frequent visitors." },
    ]}
    relatedSlugs={["/solutions/attendance", "/solutions/timesheet", "/solutions/leave"]}
    metaTitle="Visitor Management System | TimeTango"
    metaDescription="Digital visitor check-in with photo capture, host notifications and searchable visit records. Replace paper logbooks with TimeTango."
  />
);

export default VisitorSolution;
